function resizeImage(img, container) {
  if(!img || !container) {
    return;
  }

  const containerWidth = container.offsetWidth;
  const containerHeight = container.offsetHeight;
  const imgAspectRatio = img.naturalWidth / img.naturalHeight; // Use natural dimensions
  const containerAspectRatio = containerWidth / containerHeight;

  let newWidth, newHeight, left, top;

  if (imgAspectRatio > containerAspectRatio) {
    // newWidth = containerHeight * imgAspectRatio;
    newHeight = containerHeight;
    // left = -(newWidth - containerWidth) / 2;
    top = 0;
  } else {
    // newWidth = containerWidth;
    newHeight = containerWidth / imgAspectRatio;
    // left = 0;
    top = -(newHeight - containerHeight) / 2;
  }

  img.style.width = `${newWidth}px`;
  img.style.height = `${newHeight}px`;
  img.style.left = `${left}px`;
  img.style.top = `${top}px`;
  img.style.position = 'absolute';
}

const container = document.querySelector('.hero-container');
const img = container ? container.querySelector('img') : null;

function handleResize() {
  resizeImage(img, container);
}

function onLoad() {
  handleResize(); // Initial resize
}

function onResize() {
  handleResize();
}

// Run on page load
window.addEventListener('load', onLoad);

// Run on window resize
window.addEventListener('resize', onResize);
